import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useMemo } from 'react'
import { student12MenuGroups, student911MenuGroups } from '../../Data/Navigation/StudentMenuData'

// Transform student menu groups into sidebar format
const transformStudentMenu = (groups, studentId, layout, studentRoleName) => {
	return [
		{
			menutitle: studentRoleName,
			menucontent: Object.values(groups).map((g) => g.title).join(', '),
			Items: Object.entries(groups).map(([key, group]) => ({
				title: group.title,
				icon:
					group.icon === 'calendar'
						? 'widget'
						: group.icon === 'graduation'
						? 'project'
						: group.icon === 'edit'
						? 'ecommerce'
						: group.icon === 'activity'
						? 'ecommerce'
						: group.icon === 'book'
						? 'project'
						: 'widget',
				type: 'sub',
				active: true,
				children: group.items.map((item) => ({
					path: `${process.env.PUBLIC_URL}/instructor/${item.path}/${studentId}`,
					title: item.label,
					type: 'link'
				}))
			}))
		}
	]
}

// Role-based menu configuration
const getRoleBasedMenu = (userRole, studentData = null) => {
	const baseMenuItems = {
		Student911: [
			{
				menutitle: 'Student 9-11',
				menucontent: 'Planing Room, Academics, Activities, Awards, Resources',
				Items: [
					{
						title: 'Planing Room',
						icon: 'widget',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student911/agenda`, title: 'Agenda', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/schedule`, title: 'Schedule', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/personal-questions`, title: 'Career', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/college-list`, title: 'College List', type: 'link' }
						]
					},
					{
						title: 'Academics',
						icon: 'project',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student911/gradeinmonth`, title: 'Grades', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/lessons`, title: 'Courses', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/goal-questions`, title: 'SAT', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/booklist`, title: 'Readings', type: 'link' }
						]
					},
					{
						title: 'Activities & Awards',
						icon: 'ecommerce',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student911/activities`, title: 'Activities', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/awards`, title: 'Awards2', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/congressional-awards`, title: 'Congressional Awards', type: 'link' }
						]
					},
					{
						title: 'Resources',
						icon: 'contact',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student911/resource`, title: 'Resources', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student911/college-profile`, title: 'College Profile', type: 'link' }
						]
					}
				]
			}
		],

		Student12: [
			{
				menutitle: 'Student 12',
				menucontent: 'Planing Room, College, Writings',
				Items: [
					{
						title: 'Planing Room',
						icon: 'widget',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student12/agenda`, title: 'Agenda', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/schedule`, title: 'Schedule', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/timeline`, title: 'Timeline', type: 'link' }
						]
					},
					{
						title: 'College',
						icon: 'project',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student12/college-list`, title: 'List', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/deadlines`, title: 'Deadlines', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/fin-aid`, title: 'Fin. Aid', type: 'link' }
						]
					},
					{
						title: 'Writings',
						icon: 'ecommerce',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/student12/activities-awards`, title: 'Activities&Awards', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/main-essay`, title: 'Main Essays', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/supplemental-essay`, title: 'Supplementals', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/additional-info`, title: 'Additional Info', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/student12/brag-sheet`, title: 'Brag Sheet', type: 'link' }
						]
					}
				]
			}
		],

		Instructor: studentData ? 
			transformStudentMenu(
				studentData.role === 'Student12' ? student12MenuGroups : student911MenuGroups, 
				studentData.id, 
				studentData.layout,
				studentData.role === 'Student12' ? 'Student 12' : 'Student 9-11'
			) : [],

		Admin: [
			{
				menutitle: 'Admin',
				menucontent: 'Dashboard, Settings',
				Items: [
					{
						title: 'Dashboard',
						icon: 'widget',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/admin/students`, title: 'Students', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/instructors`, title: 'Instructors', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/private-notes`, title: 'Private Note', type: 'link' }
						]
					},
					{
						title: 'Settings',
						icon: 'widget',
						type: 'sub',
						active: false,
						children: [
							{ path: `${process.env.PUBLIC_URL}/admin/parameters`, title: 'Parameters', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/books`, title: 'Book List', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/class-management`, title: 'Class', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/colleges`, title: 'Desired Colleges', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/college-list-2`, title: 'Desired Colleges 2', type: 'link' },
							{ path: `${process.env.PUBLIC_URL}/admin/progress-check`, title: 'Progress Check', type: 'link' }
						]
					}
				]
			}
		],

		Parent: [
			{
				menutitle: 'Parent',
				menucontent: 'Task, Agenda, Schedule, College Profile',
				Items: [
					{
						title: 'Task',
						icon: 'widget',
						type: 'link',
						active: false,
						path: `${process.env.PUBLIC_URL}/parent/task`
					},
					{
						title: 'Agenda',
						icon: 'widget',
						type: 'link',
						active: false,
						path: `${process.env.PUBLIC_URL}/parent/agenda`
					},
					{
						title: 'Schedule',
						icon: 'widget',
						type: 'link',
						active: false,
						path: `${process.env.PUBLIC_URL}/parent/schedule`
					},
					{
						title: 'College Profile',
						icon: 'widget',
						type: 'link',
						active: false,
						path: `${process.env.PUBLIC_URL}/parent/college-profile`
					}
				]
			}
		]
	}

	return baseMenuItems[userRole] || []
}

// Hook to get menu items based on current user role and optional student context
export const useRoleBasedMenu = (studentData = null) => {
	const { user } = useAuth()
	return useMemo(() => getRoleBasedMenu(user?.role, studentData), [user?.role, studentData])
}

// Keep the original MENUITEMS for backward compatibility (default to Admin menu)
export const MENUITEMS = getRoleBasedMenu('Admin')
